import { atom } from 'jotai'
import { endOfMonth, startOfMonth } from 'date-fns'
import { IssueType, TransactionType } from '@finance-lab/utils/types'

/**
 * Atom representing the current page of the issue grid.
 */
export const issueGridCurrentPageAtom = atom(0)

/**
 * Atom representing the active tab in the issue section.
 */
export const issueActiveTabAtom = atom('current')

type FilterItem<T> = {
    disabledItems?: T
    hasMaxValueSet?: boolean
    includeGreaterValues?: boolean
    maxValue?: number
    value: T
    isSingleChoice?: boolean
}

export type IssueFilterType = {
    abb: FilterItem<string[]>
    onlyInWatchLists: FilterItem<boolean>
    warrants: FilterItem<string[]>
    issueTypes: FilterItem<Exclude<IssueType, 'ABB Directed issue' | 'Guarantor fee issue'>[]>
    marketSize: FilterItem<number[]>
    marketSizePrePublication: FilterItem<number[]>
    preMoney: FilterItem<number[]>
    offeredSize: FilterItem<number[]>
    sectors: FilterItem<string[]>
    financialAdvisors: FilterItem<string[]>
    legalAdvisors: FilterItem<string[]>
    marketplaces: FilterItem<string[]>
    dates: FilterItem<[Date, Date]>
    guarantors: FilterItem<string[]>
    issueTerms: FilterItem<string[]>
}

export const issueFiltersAtom = atom<IssueFilterType>({
    abb: { value: ['all'] },
    onlyInWatchLists: { value: false },
    warrants: { value: ['all'] },
    issueTypes: { disabled: [], value: ['Directed issue', 'IPO', 'Non-cash issue', 'Rights issue'] },
    marketSize: { value: [0, 500], maxValue: 500, includeGreaterValues: true, hasMaxValueSet: true },
    marketSizePrePublication: { value: [0, 500], maxValue: 500, includeGreaterValues: true, hasMaxValueSet: true },
    preMoney: { value: [0, 500], maxValue: 500, includeGreaterValues: true, hasMaxValueSet: true },
    offeredSize: { value: [0, 250], maxValue: 250, includeGreaterValues: true, hasMaxValueSet: true },
    sectors: { value: [] },
    financialAdvisors: { value: [] },
    legalAdvisors: { value: [] },
    marketplaces: {
        value: [],
    },
    dates: { value: [startOfMonth(new Date('2022-01-01')), endOfMonth(new Date())] },
    guarantors: { value: ['all'] },
    issueTerms: { value: ['all'] },
} as IssueFilterType)

export const issueTableDataAtom = atom({
    advisors: { value: ['financialAdvisors'] },
    priceChange: { value: ['postIssueMax'] },
})

export type NewsFilterType = {
    onlyInWatchLists: FilterItem<boolean>
    issueTypes: FilterItem<
        Array<Extract<TransactionType, 'Convertible' | 'Warrant'> | Exclude<IssueType, 'Guarantor fee issue'>>
    >
    sourceType: FilterItem<string[]>
}

const initialStateNewsFilter: NewsFilterType = {
    onlyInWatchLists: { value: false },
    issueTypes: {
        value: [
            'Rights issue',
            'Non-cash issue',
            'IPO',
            'ABB Directed issue',
            'Directed issue',
            'Warrant',
            'Convertible',
        ],
    },
    sourceType: {
        value: [],
    },
}

export const newsFiltersAtom = atom<NewsFilterType>(initialStateNewsFilter)

/**
 * Atom representing the search text input in the issue section.
 */
export const issueSearchTextfieldAtom = atom('')
